
<div class="container-fluid our-form-background " [ngStyle]="isViewOnly? {} : {'height': '30rem !important'}">
  <form #documentUploadForm="ngForm">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <app-eca-select label="Document Type"
                        [isValid]="!submitted || !!documentSummary.documentTypeId"
                        [options]="documentTypes" [isRequired]="true" [isReadOnly]="!isEditing"
                        [(selectedId)]="documentSummary.documentTypeId"
                        validationMessage="Please select the type of document that you are uploading"
                        popoverText="Document type specifies what type of document you are uploading.">
        </app-eca-select>

      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <app-eca-input label="Additional Information" [controlId]="'ctrlExtraDescription'"
                       [isRequired]="getSelectedDocumentType(documentSummary.documentTypeId)?.name === 'Other'"
                       [isReadOnly]="!isEditing"
                       [(value)]="documentSummary.extraDescription"
                       [isValid]="!submitted || !!documentSummary?.extraDescription || getSelectedDocumentType(documentSummary.documentTypeId)?.name !== 'Other'"
                       validationMessage="Please enter a further description of the type of document"
                       popoverText="You can add extra information about the document. This is mandatory if the document type selected is 'Other'">
        </app-eca-input>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="form-group">
          <app-eca-date-picker [isDisabled]="!isEditing || isViewOnly" [controlId]="'ctrlDocumentCreationDate'"
                               (dateValueChange)="disableDatesPriorSelected(documentSummary.documentCreationDate)"
                               label="Creation Date"
                               [maxDate]="creationMaxDate"
                               [(dateValue)]="documentSummary.documentCreationDate"
                               [isRequired]="true"
                               [isValid]="!saveAttempted || !!documentSummary?.documentCreationDate?.dateTime "
                               popoverText="Please enter the creation date for the document."
                               validationMessage="Please enter the date the document was created.">
          </app-eca-date-picker>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="form-group">
          <app-eca-date-picker [isDisabled]="!isEditing || isViewOnly || documentSummary?.documentCreationDate.dateTime === undefined || documentSummary?.documentCreationDate.dateTime === null" [controlId]="'ctrlDocumentExpiryDate'"
                               (dateValueChange)="setReviewDateLimit()"
                               [minDate]="selectedMinDate"
                               label="Expiry Date"
                               [(dateValue)]="documentSummary.expiryDate"
                               [isRequired]="false"
                               popoverText="Please enter the expiration date for the document.">
          </app-eca-date-picker>
        </div>
      </div>

    </div>
    <div class="row">

      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <app-eca-date-picker [isDisabled]="!isEditing || isViewOnly || documentSummary?.documentCreationDate.dateTime === undefined || documentSummary?.documentCreationDate.dateTime === null" [controlId]="'ctrlDocumentReviewDate'"
                             [minDate]="selectedMinDate"
                             [maxDate]="selectedMaxDate"
                             label="Review Date"
                             [(dateValue)]="documentSummary.reviewDate"
                             [isRequired]="false"
                             popoverText="Please enter the review date for the document.">
        </app-eca-date-picker>
      </div>
      <div class="form-group col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <label><strong>Original File Name</strong></label>

        <div class="input-group">
          <h6 class="eca-primary-text">
            <span>
              <fa-duotone-icon [icon]="['fad', 'file']" size="sm"
                               primaryColor="#03A981" secondaryColor="#3f51b5"
                               secondaryOpacity="1"></fa-duotone-icon>
            </span>
            {{ defaultFileName }}
          </h6>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="submitted && !defaultFileName">
      <div class="col">
        <div class="eca-invalid" style="margin-left: 16px">
          <strong>
            Please select a file by clicking the Choose File button
            below
          </strong>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="!isViewOnly">
      <div class="col-12 " *ngIf="isEditing">
        <div class="input-group-append">
          <app-eca-input-guide [popoverText]="filetypeTooltip"
                               icon="exclamation-circle"
                               renderHtml="true"
                               isDisabled="true"
                               style="max-width:100px !important;">
            Accepted File Types
          </app-eca-input-guide>
        </div>
        <p-fileUpload #uploader id="fileUpload" name="fileUpload" [auto]="true"
                      chooseLabel="defaultFileName ? 'Choose a different File' : 'Choose File'"
                      (onRemove)="onFileRemove()"
                      styleClass="" [multiple]="false"
                      [accept]="acceptedFileTypes" [disabled]="!isEditing"
                      [maxFileSize]="maxFileSize" customUpload="true" (uploadHandler)="onFileAdd($event)">
          <ng-template pTemplate="content">
            <p class="content-message">Drop  Your Files Here</p>
          </ng-template>
          <ng-template let-file pTemplate='file'>
            <div> {{file.name | ellipsis : 10: false}}</div>
            <div>{{ file.size / 1000 }} KB</div>
          </ng-template>
        </p-fileUpload>
      </div>
    </div>
  </form>
</div>
